module.exports = __webpack_public_path__ + "img/sb15.c847981b.png";